import { DEFAULT_LAYOUT } from '../base';
import { type AppRouteRecordRaw } from '../types';
import { IconBook } from '@arco-design/web-vue/es/icon';

const routes: AppRouteRecordRaw = {
  path: '/exam',
  redirect: '/exam/list',
  component: DEFAULT_LAYOUT,
  meta: {
    title: '考试管理',
    icon: IconBook,
    order: 2,
    hideChildrenInMenu: true,
    roles: ['admin'],
  },
  children: [
    {
      path: 'list',
      component: () => import('@/views/exam/index.vue'),
      meta: {},
    },
    {
      path: 'add-edit',
      component: () => import('@/views/exam/add-edit.vue'),
      meta: {
        title: '新增考试',
        hideInMenu: true,
        ignoreCache: true,
      },
    },
    {
      path: 'add-edit/:id',
      component: () => import('@/views/exam/add-edit.vue'),
      props: true,
      meta: {
        title: '编辑考试',
        hideInMenu: true,
        ignoreCache: true,
      },
    },
  ],
};

export default routes;
